import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Typography } from "@platform/design-system";

import RichTextEditor from "../../../shared/RichTextEditor/RichTextEditor";

import { CUSTOM_TEXT_EDITOR_SX, CUSTOM_TEXT_RADIO_SX } from "./formatters";

import type { EditMode } from "./formatters";
import type { ReactElement } from "react";

interface CustomTextModeToggleProps {
  editMode: EditMode;
  onChange: (mode: EditMode) => void;
}

/** Radio toggle between editing the benefit value and entering custom display text. */
export const CustomTextModeToggle = ({
  editMode,
  onChange,
}: CustomTextModeToggleProps): ReactElement => (
  <RadioGroup
    row
    value={editMode}
    onChange={(event) => onChange(event.target.value as EditMode)}
  >
    <FormControlLabel
      value="benefit"
      control={<Radio size="small" sx={CUSTOM_TEXT_RADIO_SX} />}
      label="Edit Benefit"
    />
    <FormControlLabel
      value="customText"
      control={<Radio size="small" sx={CUSTOM_TEXT_RADIO_SX} />}
      label="Enter Custom Text"
    />
  </RadioGroup>
);

interface CustomTextEditorFieldsProps {
  content: string;
  onUpdate: (html: string) => void;
  onCharacterCount: (count: number) => void;
  /** Most editors show this reminder; GuaranteeIssueCellEditor's popup omits it. */
  showHelperCaption?: boolean;
}

/** The rich-text input and helper caption shown once "Enter Custom Text" is selected. */
export const CustomTextEditorFields = ({
  content,
  onUpdate,
  onCharacterCount,
  showHelperCaption = true,
}: CustomTextEditorFieldsProps): ReactElement => (
  <>
    <Typography variant="body-medium">
      <strong>Custom Text</strong>
    </Typography>

    <Box sx={CUSTOM_TEXT_EDITOR_SX}>
      <RichTextEditor
        content={content}
        placeholder="Enter custom display text…"
        onUpdate={onUpdate}
        onCharacterCount={onCharacterCount}
      />
    </Box>

    {showHelperCaption && (
      <Typography variant="caption">
        Only enter custom text when editing the benefit value is not a viable
        option.
      </Typography>
    )}
  </>
);
